/**
 * @generated SignedSource<<a1c82b1fec5c3204ab5f57422ea4b2a5>>
 * @relayHash 99d6679ddf7932f021d6474b947c4ccf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8642e2b2ef16420f84a8d4ea1d4c89c873c4de0ed82cd27a3c1ccad231cf49b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d8642e2b2ef16420f84a8d4ea1d4c89c873c4de0ed82cd27a3c1ccad231cf49b",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
